import * as React from 'react';

function GuessBox({guessState, value}) {
    return <div className={"guessbox guess " + guessState}>{value}</div>
}

export default GuessBox;